<template>
  <div class="wrapper">
    <div class="page-header page-header-small">
      <parallax class="page-header-image" style="background-image: url('img/salud/07.jpg')"></parallax>
    </div>

    <div class="section">
      <div class="main">
        <div class="contact-content">
          <div class="container">
             <div class="row">
                <div class="card">
                    <div class="card-header">
                        <div class="col-md-6">
                            <h5 class="card-title">Ubicacion Geografica y Tipo de Prestador</h5>
                        </div>                        
                    </div>
                <!-- <div class="card-body row"> -->                
                    <fieldset>
                        <div class="form-group">
                            <div class="row">
                              <div class="col-md-4">
                                  <label>Provincia</label>
                                  <el-select
                                  clearable 
                                  filterable
                                  v-model="provinciaId"
                                  class="select-default"
                                  placeholder="Provincias"
                                  @change="onChangeProvincia"
                               
                                  >
                                  <el-option
                                      v-for="item in optionProvincias"
                                      class="select-default"
                                      :key="item.ProvinciaId"
                                      :label="item.ProvinciaNombre"
                                      :value="item.ProvinciaId"
                                  ></el-option>
                                  </el-select>
                              </div>
                              <div class="col-md-4" v-if="showLocalidades">
                                  <label>Localidad</label>
                                  <el-select clearable filterable v-model="localidadId" class="select-default" placeholder="Localidades">
                                  <el-option
                                      v-for="item in optionLocalidades"
                                      :key="item.LocalidadId"
                                      :label="item.LocalidadNombre"
                                      :value="item.LocalidadId"
                                  ></el-option>
                                  </el-select>
                              </div>
                              <div class="col-md-4" v-if="!showLocalidades">
                                  <label>Barrio</label>
                                  <el-select clearable filterable v-model="barrioId" class="select-default" placeholder="Barrios">
                                  <el-option
                                      v-for="item in optionBarrios"
                                      :key="item.BarrioId"
                                      :label="item.BarrioNombre"
                                      :value="item.BarrioId"
                                  ></el-option>
                                  </el-select>
                              </div>                              
                              <div class="col-md-4">
                                  <label>Seccional</label>
                                  <el-select clearable filterable v-model="seccionalId" class="select-default" placeholder="Seccionales">
                                  <el-option
                                      v-for="item in optionSeccionales"
                                      :key="item.SeccionalId"
                                      :label="item.SeccionalNombre"
                                      :value="item.SeccionalId"
                                  ></el-option>
                                  </el-select>
                              </div>
                          </div>  
                          <br>
                          <div class="row">
                              <div class="col-md-4">
                                  <label>Planes</label>
                                  <el-select
                                  clearable
                                  filterable 
                                  v-model="planId"
                                  class="select-default"
                                  placeholder="Selecciona un Plan"                                  
                                  >
                                  <el-option
                                      v-for="item in optionPlanes"
                                      class="select-default"
                                      :key="item.PlanId"
                                      :label="item.PlanNombre"
                                      :value="item.PlanId"
                                  ></el-option>
                                  </el-select>
                              </div>
                              <div class="col-md-4">
                                  <label>Tipo de Prestador</label>
                                  <el-select
                                  clearable
                                  filterable 
                                  v-model="tipoCartillaId"
                                  class="select-default"
                                  placeholder="Tipo de Prestador"
                                  @change="onChangeCartilla"
                                  >
                                  <el-option
                                      v-for="item in optionTipoCartilla"
                                      :key="item.TipoCartillaId"
                                      :label="item.TipoCartillaNombre"
                                      :value="item.TipoCartillaId"
                                  ></el-option>
                                  </el-select>
                              </div>
                              <div class="col-md-4" v-if="showEspecialidades">
                                  <label>Especialidad</label>
                                  <el-select
                                  clearable
                                  filterable 
                                  class="select-default"
                                  v-model="especialidadId"
                                  placeholder="Especialidades"
                                  >
                                  <el-option
                                      v-for="item in optionEspecialidades"
                                      :key="item.SubEspecialidaId"
                                      :label="item.SubEspecialidadNombre"
                                      :value="item.SubEspecialidaId"
                                  ></el-option>
                                  </el-select>
                              </div>
                              <div class="col-md-4">
                                <label>Nombre</label>
                                <fg-input type="text" v-model="nombrePrestador" name="nombrePrestador"  placeholder="Nombre del Prestador"></fg-input>
                              </div>
                            </div>
                        </div>    
                        <div class="form-group">  
                          <br>
                          <div class="row">
                              <div class="col-md-12">
                                <button class="btn-sm btn-round btn-primary" type="btn-round" @click="buscar()">Buscar</button>                                 
                                <button class="btn-sm btn-round" type="btn-round" @click="downloadResult()"><i class="fa fa-download"></i>Descargar</button> 
                                <button class="btn-sm btn-round btn-danger" type="btn-round" @click="cleanFilter()">Limpiar Filtros</button>                                                                                  
                              </div>                                                             
                          </div>                                                                                  
                        </div>
                    </fieldset>                
                </div>

                <div class="card">
                    <div class="card-header">                                             
                        <br>
                    </div>
                    <div class="card-body row">
                        <div class="col-sm-12">                        
                        <el-table :row-class-name="tableRowClassName" :data="queriedData" header-row-class-name="text-primary">
                            <el-table-column prop="Nombre" label="Nombre"></el-table-column>
                            <el-table-column prop="Direccion" label="Dirección"></el-table-column>
                            <el-table-column prop="Telefono" label="Telefono"></el-table-column>                            
                        </el-table> 
                        <div class="col-sm-6">
                          <p-pagination
                            class="pull-right"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="pagination.total"
                          ></p-pagination>
                        </div>                       
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { Button, InfoSection, FormGroupInput } from '@/components';
import { Table, TableColumn } from 'element-ui';
import { Select, Option } from 'element-ui';
// import CartillaSearchForm from "../../components/ZaiqComponents/GridFilter/CartillaSearchForm";
// import ZaiqFormGenerator from "../../components/ZaiqComponents/FormGenerator/ZaiqFormGenerator";
import PPagination from '../../components/Pagination';

Vue.use(Table);
Vue.use(TableColumn);
export default {
  components: {
    PPagination,
    [FormGroupInput.name]: FormGroupInput,
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select
  },
  data() {
    return {
      pagination: {
        perPage: 100,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      tableData: [],
      showEspecialidades: false,
      showLocalidades: true,
      planId: '',
      provinciaId: '',
      localidadId: '',
      seccionalId: '',
      nombrePrestador: '',
      barrioId: '',
      tipoCartillaId: '',
      especialidadId: '',
      optionPlanes: {},
      optionProvincias: {},
      optionLocalidades: [],
      optionSeccionales: {},
      optionBarrios: {},
      optionTipoCartilla: {},
      optionEspecialidades: {},
      model: [
        {
          provincia: {}
        }
      ]
    };
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 != 0) {
        return 'table-info';
      }
      return '';
    },
    handleLike(index, row) {
      alert(`Your clicked on Like button`);
    },
    handleEdit(index, row) {
      alert(`Your want to edit ${row.name}`);
    },
    handleDelete(index, row) {
      alert(`Your want to delete ${row.name}`);
    },
    cleanFilter() {
      (this.showEspecialidades = false),
        (this.tableData = []),
        (this.provinciaId = ''),
        (this.planId = ''),
        (this.localidadId = ''),
        (this.seccionalId = ''),
        (this.nombrePrestador = ''),
        (this.barrioId = ''),
        (this.tipoCartillaId = ''),
        (this.especialidadId = '');
    },
    async buscar() {
      if (this.tipoCartillaId == '') {
        this.$noty.error('Debe seleccionar un tipo de prestador');
        return null;
      }
      if (this.tipoCartillaId == 1 && this.especialidadId == '') {
        this.$noty.error('Debe seleccionar una especialidad');
        return null;
      }

      if (this.planId == '') {
        this.$noty.error('Debe seleccionar un Plan');
        return null;
      }

      await this.$osapm()
        .get('Afiliado/getPrestadores', {
          params: {
            provinciaId: this.provinciaId,
            seccionalId: this.seccionalId,
            planId: this.planId,
            localidadId: this.localidadId,
            barrioId: this.barrioId,
            nombre: this.nombrePrestador,
            TipoCartilla: this.tipoCartillaId,
            especialidadId: this.especialidadId,
            page: 0,
            pageSize: 5000,
            planId: this.planId
          }
        })
        .then(result => {
          this.tableData = result.data.Lista;
          console.log(result.data.Lista.length);
          if (result.data.Lista.length == 0) {
            this.$noty.warning(
              'No se encuentran registros de acuerdo a los filtros utilizados'
            );
          }
        });
    },
    async downloadResult() {
      await this.$file.download(
        this.$osapm(),
        'Afiliado/getPrestadoresPdf',
        {
          provinciaId: this.provinciaId,
          seccionalId: this.seccionalId,
          localidadId: this.localidadId,
          barrioId: this.barrioId,
          nombre: this.nombrePrestador,
          TipoCartilla: this.tipoCartillaId,
          especialidadId: this.especialidadId,
          page: 0,
          pageSize: 100,
          planId: this.planId
        },
        'Cartilla_Prestadores.pdf',
        sucess => {},
        error => {
          this.$noty.error(
            'Debe filtrar los datos antes de intentar descargar'
          );
        }
      );
    },

    // onFormSubmit(index, row) {
    //   alert(`click en search`);
    // },
    async loadEspecialidades() {
      await this.$osapm()
        .get('misc/getEspecialidadesCartilla', {
          params: { provinciaId: this.provinciaId }
        })
        .then(result => {
          this.optionEspecialidades = result.data;
        });
    },

    async onChangeProvincia() {
      this.localidadId = "";
      this.barrioId="";
      this.optionLocalidades=[];
      this.optionBarrios=[];

      if (this.provinciaId=="")
        return;

      if (this.provinciaId == "C") {
        this.showLocalidades = false;
        
        await this.$osapm()
        .get("misc/getBarrios", {
          params: { provinciaId: this.provinciaId }
        })
        .then(result => {
          this.optionBarrios = result.data;
        });

      } else {
        this.showLocalidades = true;
        
        await this.$osapm()
        .get("misc/getLocalidades", {
          params: { provinciaId: this.provinciaId }
        })
        .then(result => {
          this.optionLocalidades = result.data;
        });
      }
    },
    async onChangeCartilla() {
      if (this.tipoCartillaId == 1) {
        this.loadEspecialidades();
        this.showEspecialidades = true;
      } else {
        this.showEspecialidades = false;
        this.especialidadId='';
      }
    }
  },

  computed: {
    pagedData() {
      return this.tableData.slice(this.from, this.to);
    },
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      this.pagination.total = this.tableData.length;
      return this.pagedData;

      let result = this.tableData.filter(row => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString();
          if (rowValue.includes && rowValue.includes(this.searchQuery)) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.tableData.length;
      return this.tableData.length;
    }
  },

  async mounted() {
    await this.$osapm()
      .get('misc/getProvincias', {
        params: {}
      })
      .then(result => {
        this.optionProvincias = result.data;
      });

    await this.$osapm()
      .get('misc/getPlanesVigentes', {})
      .then(result => {
        this.optionPlanes = result.data;
      });

    await this.$osapm()
      .get('misc/getTiposCartilla', {
        params: {}
      })
      .then(result => {
        this.optionTipoCartilla = result.data;
      });

    await this.$osapm()
      .get('misc/getSeccionales', {
        params: {}
      })
      .then(result => {
        this.optionSeccionales = result.data;
      });
  }
};
</script>
<style scoped>
fieldset {
  min-width: 0;
  padding-left: 15px;
  padding-right: 15px;
  margin: 0;
  border: 0;
}
.form-group >>> .el-input__inner[readonly] {
  background-color: #888888 !important;
}
.el-select {
  background-color: #ffffff;
  cursor: not-allowed;
  color: #9a9a9a;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-download {
  margin-left: 15px;
  margin-top: 5px;
}
</style>

<!-- <template>
  <div class="wrapper">
    <div class="page-header page-header-small">
      <parallax class="page-header-image" style="background-image: url('img/salud/07.jpg')"></parallax>
    </div>

    <div class="section">
      <div class="main">
        <div class="contact-content">
          <div class="container">
             <div>
                <div class="card">
                <div class="card-header">
                    <h5 class="card-title">Ubicacion Geografica y Tipo de Prestador</h5>
                </div>
                <!-- <div class="card-body row"> -->
                <div class>
                    <fieldset>
                    <div class="form-group">
                        <div class="row">
                        <div class="col-md-4">
                            <label>Provincia</label>
                            <el-select
                            v-model="provinciaId"
                            class="select-default"
                            placeholder="Provincias"
                            @input="onChangeProvincia"
                            >
                            <el-option
                                v-for="item in optionProvincias"
                                :key="item.ProvinciaId"
                                :label="item.ProvinciaNombre"
                                :value="item.ProvinciaId"
                            ></el-option>
                            </el-select>
                        </div>
                        <div class="col-md-4" v-if="showLocalidades">
                            <label>Localidad</label>
                            <el-select v-model="localidadId" class="select-default" placeholder="Localidades">
                            <el-option
                                v-for="item in optionLocalidades"
                                :key="item.LocalidadId"
                                :label="item.LocalidadNombre"
                                :value="item.LocalidadId"
                            ></el-option>
                            </el-select>
                        </div>
                        <div class="col-md-4" v-if="!showLocalidades">
                            <label>Barrio</label>
                            <el-select v-model="barrioId" class="select-default" placeholder="Barrios">
                            <el-option
                                v-for="item in optionBarrios"
                                :key="item.BarrioId"
                                :label="item.BarrioNombre"
                                :value="item.BarrioId"
                            ></el-option>
                            </el-select>
                        </div>
                        <!-- </div>
                    
                        <div class="row">-->
                        <div class="col-md-4">
                            <label>Seccional</label>
                            <el-select v-model="seccionalId" class="select-default" placeholder="Seccionales">
                            <el-option
                                v-for="item in optionSeccionales"
                                :key="item.SeccionalId"
                                :label="item.SeccionalNombre"
                                :value="item.SeccionalId"
                            ></el-option>
                            </el-select>
                        </div>
                        <div class="col-md-4">
                            <label>Tipo de Prestador</label>
                            <el-select
                            v-model="tipoCartillaId"
                            class="select-default"
                            placeholder="Tipo de Prestador"
                            @change="onChangeCartilla"
                            >
                            <el-option
                                v-for="item in optionTipoCartilla"
                                :key="item.TipoCartillaId"
                                :label="item.TipoCartillaNombre"
                                :value="item.TipoCartillaId"
                            ></el-option>
                            </el-select>
                        </div>
                        <div class="col-md-4" v-if="showEspecialidades">
                            <label>Especialidad</label>
                            <el-select
                            class="select-default"
                            v-model="especialidadId"
                            placeholder="Especialidades"
                            >
                            <el-option
                                v-for="item in optionEspecialidades"
                                :key="item.SubEspecialidaId"
                                :label="item.SubEspecialidadNombre"
                                :value="item.SubEspecialidaId"
                            ></el-option>
                            </el-select>
                        </div>
                        </div>

                        <div class="row">
                        <div class="col-md-12">
                            <p-button type="info" @click="buscar()">Buscar</p-button>
                            <p-button type="danger" @click="cleanFilter()">Limpiar Filtros</p-button>                
                        </div>
                        </div>
                    </div>
                    </fieldset>
                </div>
                </div>

                <div class="card">
                <div class="card-header">
                    <h5 class="card-title">Cartilla de prestadores</h5>
                    <div class="category">Items por Página</div>
                    <div class="col-md-12">
                    <el-select class="select-default" v-model="pagination.perPage" placeholder="Per page">
                        <el-option
                        class="select-default"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                    <p-button type="info" class="btn-download" @click="downloadResult()"><i class="fa fa-download"></i> Descargar</p-button>
                    </div>                       
                    <br>
                </div>
                <div class="card-body row">
                    <div class="col-sm-12">
                    <!-- tableData -->
                    <el-table :row-class-name="tableRowClassName":data="queriedData" header-row-class-name="text-primary">
                        <el-table-column prop="Nombre" label="Nombre"></el-table-column>
                        <el-table-column prop="Direccion" label="Dirección"></el-table-column>
                        <el-table-column prop="Telefono" label="Telefono"></el-table-column>
                        <el-table-column prop="EspecialidadNombre" label="Especialidad"></el-table-column>
                    </el-table>
                    <div class="col-sm-6">
                        <p-pagination
                        class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total"
                        ></p-pagination>
                    </div>
                    </div>
                </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- </div>
</template>
<script>
import { Table, TableColumn, Tooltip } from "element-ui";
import Vue from "vue";

export default {
  name: "cartillaPrestadores",
  bodyClass: "home",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      tableData: [
        {
          name: "Andrew Mike",
          job: "Develop",
          salary: "€ 99,225",
          active: false
        },
        {
          name: "John Doe",
          job: "Design",
          salary: "€ 89,241",
          active: false
        },
        {
          name: "Alex Mike",
          job: "Design",
          salary: "€ 92,144",
          active: false
        },
        {
          name: "Mike Monday",
          job: "Marketing",
          salary: "€ 49,990",
          active: true
        },
        {
          name: "Paul dickens",
          job: "Communication",
          salary: "€ 69,201",
          active: true
        }
      ]
    };
  },
  methods: {
    async sendForm() {
      let self = this;
      var result = await this.$zaiq()
        .post("contacto/create", this.form)
        .then(success => {
          self.cleanForm();
          self.$noty.success("Se ha enviado correctamente el mensaje.");
        })
        .catch(error =>
          self.$noty.error("Ha ocurrido un error intentando enviar el mensaje.")
        );
    },
    dismissAlert() {
      this.isSuccessHidden = true;
      this.isErrorHidden = true;
    },
    cleanForm() {
      this.form = {};
    }
  }
};
</script>
<style>
</style> --> 